<template>
  <div>
    <div class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped">
          <thead>
            <tr class="row global-thead-dark thead-property pl-1">
              <th class="col-4">
                Necesidades
              </th>
            </tr>
          </thead>
          <tbody v-if="rows.length > 0">
            <tr class="row pl-2">
              <td class="col-md-12 pl-3">
                <BadgeTitle
                  v-for="item in rows"
                  :key="item.id"
                  :title="item.name"
                  :has-icon="!(isDraft && canDelete)"
                  @delete="deleteClick(item)"
                />
              </td>
            </tr>
            <tr class="row pl-2">
              <td v-if="selectedInterpreterLevel" class="col-md-12 pl-3">
                <label>
                  Nivel de Dominio que se requiere de Lenguaje de Señas del
                  Intérprete:
                </label>
                <br />
                <b>{{ selectedInterpreterLevel }}</b>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="w-100 text-center">
              <div
                v-if="rows.length == 0 && isDraft && canDelete"
                class="text-center"
              >
                <button
                  class="btn bg-light-white w-50 pt-1 mt-3"
                  @click="addClick()"
                >
                  <i class="fas fa-file-plus pr-4 text-green" />
                  <span class="text-button-add-document">
                    Presione aquí para poder añadir necesidades
                  </span>
                </button>
              </div>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div
      v-if="rows.length > 0 && isDraft && canDelete"
      class="float-right pb-3"
    >
      <button
        type="button"
        class="btn btn-green drop-item float-right"
        @click="addClick"
      >
        <i class="fas fa-file-plus text-white pr-2" />
        <span class="text-white">Modificar</span>
      </button>
    </div>
    <br />
    <div
      v-if="rows.length > 0 && activateAssistantServiceNeedGuideParam"
      class="pt-5"
    >
      <HeaderAssistantQuestion
        v-for="item in listExcludeNoconsideration"
        :key="item.id"
        class="pb-3"
        :isDraft="isDraft"
        :can-delete="canDelete"
        :id="item.id"
        :justify="item.isJustifiedNeed"
        :name="item.name"
        :validate="validate"
        :inappropriate-conduct-alternative="inappropriateConductAlternative"
        :has-any-assistant-service-need="hasAnyAssistantServiceNeed"
        @on-justified-flag-change="onJustifiedFlagChange"
        @delete="deleteClick(item)"
      />
    </div>
    <div
      v-if="
        activateAssistantServiceNeedGuideParam && hasAnyAssistantServiceNeed
      "
      class="pt-5"
    >
      <HeaderAssistantQuestion
        class="pb-3"
        name="Preguntas Adicionales"
        :isDraft="isDraft"
        :can-delete="canDelete"
        :justify="true"
        :id="0"
        :inappropriate-conduct-alternative="0"
        :validate="validate"
        :has-any-assistant-service-need="hasAnyAssistantServiceNeed"
        :additional-questions="additionalQuestionsFiltered"
        :all-additional-questions="sharedAdditionalQuestions"
        @on-justified-flag-change="onJustifiedFlagChange"
        @delete="deleteClick(item)"
      />
    </div>
    <div
      v-if="
        activateAssistantServiceNeedGuideParam && canShowRegularRoomQuestion
      "
      class="pt-2"
    >
      <HeaderAssistantQuestion
        :trigger-scroll="true"
        class="pb-3"
        name="Integración en sala Regular"
        :isDraft="isDraft"
        :can-delete="canDelete"
        :justify="true"
        :id="0"
        :inappropriate-conduct-alternative="0"
        :validate="validate"
        :has-any-assistant-service-need="hasAnyAssistantServiceNeed"
        :additional-questions="regularRoomQuestions"
        :all-additional-questions="regularRoomQuestions"
        @on-justified-flag-change="onJustifiedFlagChange"
        @delete="deleteClick(item)"
      />
    </div>
  </div>
</template>

<script>
import { BadgeTitle } from '@/components/pei/shared';
import HeaderAssistantQuestion from '@/components/pei/tabs/components/tab6/HeaderAssistantQuestion.vue';
import peiAssistantsNeeds from '@/utils/constants/pei/peiAssistantsNeeds';
import needsService from '@/services/pei/serviceNeedQuestionnaire';
import AnswerType from '@/utils/constants/pei/serviceNeedQuestionnaire/answerType';
import store from '@/store/index';
import generalService from '@/services/pei/general';
import alternatePlacements from '@/utils/constants/alternatePlacements';

export default {
  name: 'NeedsStudent',
  components: {
    BadgeTitle,
    HeaderAssistantQuestion,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
      required: true,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    selectedInterpreterLevel: {
      type: String,
      default: '',
      required: false,
    },
    activateAssistantServiceNeedGuideParam: {
      type: Boolean,
      default: false,
      required: false,
    },
    validate: {
      type: Boolean,
      default: false,
      required: true,
    },
    inappropriateConductAlternative: {
      type: [String, Number],
      default: 0,
      validator(value) {
        return value === null || typeof value === 'number';
      },
    },
  },
  data() {
    return {
      additionalQuestions: [],
      recommendedLocationId: 0,
    };
  },
  async mounted() {
    this.getRecommendedLocationAsync();
    this.additionalQuestions = await this.getAdditionalQuestion();
  },
  computed: {
    canShowRegularRoomQuestion() {
      // JSF: US143642 - Show regular room question if the recommended location is related to regular room
      return (
        this.hasAnyAssistantServiceNeed &&
        this.regularRoomQuestions.length > 0 &&
        [
          alternatePlacements.SalonRegularConServiciosRelacionados,
          alternatePlacements.SalonRegularConServiciosSuplementarios,
        ].some((id) => this.recommendedLocationId === id)
      );
    },
    additionalQuestionsFiltered() {
      return this.sharedAdditionalQuestions.filter((x) =>
        this.canShowAdditionalQuestion(x.id)
      );
    },
    sharedAdditionalQuestions() {
      const sharedAdditionalQuestionIds = [19, 20, 21, 22];
      return this.additionalQuestions.filter((question) =>
        sharedAdditionalQuestionIds.includes(question?.id)
      );
    },
    regularRoomQuestions() {
      const regularRoomQuestionId = 25; // question "¿cómo se integrará el apoyo del asistente dentro del salón regular?"
      return this.additionalQuestions
        .filter((x) => x?.id === regularRoomQuestionId)
        .map((question) => ({ ...question }));
    },
    selectedPeiId() {
      return store.getters.SelectedPei;
    },
    listExcludeNoconsideration() {
      return this.rows.filter((row) => row.id !== 87);
    },
    hasAnyAssistantServiceNeed() {
      const assistantServiceNeedIds = [
        peiAssistantsNeeds.alimentacion,
        peiAssistantsNeeds.movilidad,
        peiAssistantsNeeds.transportacion,
        peiAssistantsNeeds.higiene,
        peiAssistantsNeeds.sillaDeRueda,
        peiAssistantsNeeds.apoyoConductual,
        peiAssistantsNeeds.cateterizacion,
        peiAssistantsNeeds.colonostomia,
        peiAssistantsNeeds.ansiedadSevera,
      ];

      return (
        this.rows.length > 0 &&
        assistantServiceNeedIds.some((id) =>
          this.rows.some((row) => row.id === id)
        )
      );
    },
    additionalQuestionId() {
      return 19;
    },
  },
  methods: {
    async getRecommendedLocationAsync() {
      const { data: response } = await generalService.getRecommendedLocation(
        this.selectedPeiId
      );
      this.recommendedLocationId = response?.alternatePlacementCode;
    },
    getAdditionalQuestionAnswers(questionId) {
      return this.additionalQuestions.find((x) => x.id === questionId)
        ?.submittedAnswerTypeId;
    },
    canShowAdditionalQuestion(questionId) {
      if (questionId === 19) {
        return true;
      }
      const firstAdditionalIsYes =
        this.getAdditionalQuestionAnswers(19) === AnswerType.Yes;
      if (questionId === 20) {
        return firstAdditionalIsYes;
      }
      if (questionId === 21) {
        return (
          firstAdditionalIsYes &&
          this.getAdditionalQuestionAnswers(20) === AnswerType.Yes
        );
      }
      if (questionId === 22) {
        return (
          firstAdditionalIsYes &&
          this.getAdditionalQuestionAnswers(20) === AnswerType.Yes &&
          this.getAdditionalQuestionAnswers(21) === AnswerType.Yes
        );
      }

      return false;
    },
    addClick() {
      this.$emit('save');
    },
    deleteClick(item) {
      this.$emit('delete', item);
    },
    onJustifiedFlagChange(item) {
      this.$emit('on-justified-flag-change', item);
    },
    async getAdditionalQuestion() {
      const response = (
        (await needsService.getAdditionalQuestions({
          peiId: this.selectedPeiId,
          peiCodeId: -1,
        })) || []
      ).map((x) => ({
        ...x,
        possibleAnswers: x.possibleAnswers.filter((item) =>
          [AnswerType.Yes, AnswerType.No].includes(item.id)
        ),
      }));

      return response;
    },
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-success-outline {
  height: 38px;
  border: 1px solid #2db782 !important;
  color: #2db782;
}

.btn-success-outline:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.row.pl-2 >>> .col-md-12.pl-3 {
  padding: 0;
  border-top: 0px;
  margin-top: 15px;
}
</style>
